import InvoiceIncoming from '@/views/invoices/Incoming.vue'

const router = {
    path: '/invoices/incoming',
    name: 'Incoming Invoices',
    component: InvoiceIncoming,
    meta: {
        title: 'Incoming Invoices'
    }
  };

export default router
